import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type CalibrateAdminRouteProps = {
  children: ReactNode;
  allowRegularInternalUsers?: boolean;
};

const CalibrateAdminRoute = ({
  children,
  allowRegularInternalUsers = false,
}: CalibrateAdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pp = user?.platform_profile;

  if (user && !user.is_pass_reset && !(pp && !pp.is_pass_reset)) {
    return <Navigate to="/reset-password" replace />;
  }

  const isRegularInternalUser =
    !!pp &&
    !pp.is_archived &&
    pp.user_type === "internal" &&
    !pp.is_superuser &&
    !pp.is_calibrate_manager;
  const isPlatformAdmin =
    !!pp && !pp.is_archived && (pp.is_superuser || pp.is_calibrate_manager);

  const hasAccess =
    isPlatformAdmin || (allowRegularInternalUsers && isRegularInternalUser);

  if (!user || !hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CalibrateAdminRoute;
